import React from "react";
import { Radio, Form } from "antd";
import { Controller } from "react-hook-form";
import { getError } from "../../../utils/form";

const itemLayout = {
  labelCol: {
    sm: { span: 8 },
    lg: { span: 10 },
    
  },
  wrapperCol: {
    sm: { span: 16 },
    lg: { span: 14 },
  },
};

const ControlledRadio = ({
  control,
  errors,
  name,
  label,
  required,
  options,
  disabled = false,
}) => {
  const error = getError({ errors, name });
  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Form.Item
          label={label}
          {...itemLayout}
          required={required}
          labelAlign="left"
          validateStatus={error ? "error" : "success"}
          help={error?.message}
        >
          <Radio.Group {...field} disabled={disabled} options={options} style={{ width: "100%" }} />
        </Form.Item>
      )}
    />
  );
};

export default ControlledRadio;
